import React, { ReactNode } from "react";
import "./style.scss";

type SharedCardProps = {
  children: ReactNode;
  className?: string;
};

export const SharedCard: React.FC<SharedCardProps> = ({
  children,
  className,
}) => {
  return <div className={`sharedCard ${className || ""}`}>{children}</div>;
};
